/**
 * sessionStorage key AppShell's onSignOut sets right before calling
 * logoutRedirect(), and App.tsx's `signedOut` gate reads to decide whether to
 * render the passive <SignedOut/> screen instead of re-entering
 * <MsalAuthenticationTemplate> (which would auto-redirect back into Entra —
 * the sign-out loop). Single source of truth so the writer (AppShell.tsx)
 * and reader (App.tsx) can't drift apart.
 *
 * sessionStorage (not localStorage): per-tab, matching MSAL's own cache scope
 * (msalConfig.ts), so one tab's marker can't be cleared by another tab. It
 * still survives the same-tab logout -> Entra -> back redirect round-trip —
 * that's a single top-level browsing context the whole way, which is exactly
 * how MSAL's own sessionStorage cache survives the same trip.
 */
export const SIGNED_OUT_KEY = 'viq_signed_out';
